// Shared copy for the About page (SPA + prerender) and the short corrections note.
module.exports = {
  email: 'info@dailytourneys.com',
  title: 'About Daily Tourneys: Data Sources & Corrections | Daily Tourneys',
  description: 'How Daily Tourneys compiles poker room tournament schedules, how to report a correction, and how the site is funded.',
  h1: 'About Daily Tourneys',
  lead: 'Daily Tourneys is a free directory of daily and weekly poker tournament schedules at U.S. casinos and card rooms.',
  sections: [
    {
      h: 'Where the schedules come from',
      p: [
        'Schedules are compiled from public information that poker rooms post themselves, such as their websites, calendars, and flyers. We list a day, start time, and buy-in only when we have all three. If a room has no schedule on file, its page shows contact details and says so instead of guessing.',
        'Rooms change calendars for holidays, series, and staffing, and a listing can be out of date. Always confirm the start time and late registration with the room before you go.'
      ]
    },
    {
      h: 'Report a correction or update a listing',
      p: [
        'If a schedule, buy-in, or room detail is wrong or a room has closed, email info@dailytourneys.com with the room name and what changed. Room staff can use the same address to ask us to update or remove a listing.'
      ]
    },
    {
      h: 'How the site is funded',
      p: [
        'Daily Tourneys is free to use. The site shows one sponsored banner for a third-party offer (Stake.us), and we may earn a commission if you sign up through it. It is clearly separate from the tournament listings and does not influence which rooms or schedules appear. The banner is for adults 21+ only; play responsibly.',
        'When you click that banner we count the click to see whether it is used. We do not store your IP address for this, and we do not run advertising or analytics trackers on the rest of the site.'
      ]
    },
    {
      h: 'Independence',
      p: [
        'Daily Tourneys is an independent site. We are not affiliated with any poker room, and room names, locations, and links belong to their respective owners.'
      ]
    },
    {
      h: 'Contact',
      p: [
        'info@dailytourneys.com'
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./js/about-copy.js